import React, { useState, useEffect } from 'react';
import Lottie from "react-lottie";
import * as emailjs from 'emailjs-com';
import * as animationData from '../utils/lotties/person3.json';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import '../styles.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ContactSection = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      Swal.fire({
        icon: 'warning',
        title: t('contactSection.formIncomplete'),
        text: t('contactSection.formIncompleteMessage'),
        confirmButtonColor: '#40e0d0',
      });
      return; 
    }

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
    };

    emailjs
      .send(
        'service_p2f6gvh',
        'template_0wgzow3',
        templateParams,
        'saYF3Sc2NQSf731hO'
      )
      .then(
        (response) => {
          console.log('Correo enviado con éxito:', response.status, response.text);
          Swal.fire({
            icon: 'success',
            title: t('contactSection.messageSent'),
            text: t('contactSection.messageSentResponse', { name: formData.name }),
            confirmButtonColor: '#40e0d0',
          });
          setFormData({ name: '', email: '', message: '' });
        },
        (err) => {
          console.error('Error al enviar el correo:', err);
          Swal.fire({
            icon: 'error',
            title: t('contactSection.errorSending'),
            text: t('contactSection.errorSendingMessage'),
            confirmButtonColor: '#d33',
          });
        }
      );
  };

  return (
    <section
      id="contact"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '20vh',
        paddingBottom: '16vh',
        textAlign: 'center',
      }}
    >
      <div data-aos="fade-up">
        <h1>{t('contactSection.title')}</h1>
        <p className="subtitle" style={{ color: 'white' }}>{t('contactSection.subtitle')}</p>
      </div>
      
      <div
        data-aos="fade-up"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: '1200px',
          padding: '20px',
          flexDirection: 'row',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ flex: 1, paddingRight: '20px', minWidth: '300px' }}>
          <Lottie
            options={defaultOptions}
            height="100%"
            width="100%"
            isClickToPauseDisabled={true}
          />
        </div>

        <div style={{ flex: 1, paddingLeft: '20px', minWidth: '300px', padding: '20px' }} data-aos="fade-up">
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="name" style={{ marginBottom: '10px', color: 'white' }}>{t('contactSection.name')}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              style={{
                padding: '10px',
                marginBottom: '20px',
                borderRadius: '5px',
                border: '1px solid #ccc',
              }}
              className="input-focus"
              required
            />

            <label htmlFor="email" style={{ marginBottom: '10px', color: 'white' }}>{t('contactSection.email')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              style={{
                padding: '10px',
                marginBottom: '20px',
                borderRadius: '5px',
                border: '1px solid #ccc',
              }}
              className="input-focus"
              required
            />

            <label htmlFor="message" style={{ marginBottom: '10px', color: 'white' }}>{t('contactSection.message')}</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              style={{
                padding: '10px',
                marginBottom: '20px',
                borderRadius: '5px',
                border: '1px solid #ccc',
              }}
              required
              className="input-focus"
            ></textarea>

            <button
              type="submit"
              style={{
                padding: '10px 20px',
                backgroundColor: '#40e0d0',
                border: 'none',
                color: 'white',
                borderRadius: '5px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#48b7b0'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#40e0d0'}
            >
              {t('contactSection.button')}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
